<!--

    V 0.1.0 - 2024-07-10
       - Added to allow selection of day for Day Tripper

  -->
<template>
  <v-container>
    <v-progress-linear v-if="isLoading"
                       indeterminate
                       color="blue"></v-progress-linear>
    <v-date-picker v-model="date"
                   :allowed-dates="allowedDates"
                   full-width
                   @input="onDateSelected"
                   ref="picker"
                   :picker-date.sync="pickerDate"
                   :events="functionEvents">
      <template v-slot:header>
        <div class="d-flex justify-space-between align-center pa-2">
          <v-btn icon @click="prevMonth">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <div>
            {{ displayDate }}
          </div>
          <v-btn icon @click="nextMonth">
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </div>
      </template>
      <template v-slot:day="{ date, isSelected }">
        <div :class="['v-btn', { 'v-btn--active': isSelected }, eventClass(date)]">
          {{ new Date(date).getDate() }}
        </div>
      </template>
    </v-date-picker>

    <v-card v-if="debugMode">
      <v-row>
        <v-col>
          <p>First Day: {{ firstDay }}</p>
          <p>Last Day: {{ lastDay }}</p>
          <p>selectedDate : {{ date }}</p>
          <p>UnitID : {{ UnitID }}</p>
          <p>VehicleReg : {{ VehicleReg }}</p>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import { format, parseISO, addDays } from 'date-fns'

export default {
  data () {
    return {
      debugMode: this.$debug,
      date: null,
      pickerDate: null,
      selectedDate: null,
      firstDay: '',
      lastDay: '',
      today: new Date().toISOString().substr(0, 10),
      Driver: 'None',
      UnitModelId: 0,
      VehicleID: -1,
      isLoading: false,
      VehicleReg: 'None',
      UnitID: '',
      events: null
    }
  },

  computed: {
    displayDate () {
      return this.selectedDate
        ? new Date(this.selectedDate).toDateString()
        : new Date().toDateString()
    }
  },

  created () {
    this.VehicleReg = this.$route.params.VehicleReg
    this.UnitID = this.$route.params.UnitID
    this.date = this.$route.params.dayDate

    if (this.date) {
      const pathDate = new Date(this.date)
      this.selectedDateModel = pathDate
    }
  },

  watch: {
    pickerDate (val) {
      this.updateDisplayedMonth()
    }
  },

  methods: {
    /* eslint-disable no-unused-expressions */
    functionEvents (date) {
      var res = []

      if (this.events === null) {
        return res
      }

      this.events.some((event) => event.StartTime.startsWith(date))
        ? res.push('green')
        : ''

      this.events.some(
        (event) =>
          event.StartTime.startsWith(date) && event.ViolationAllCount > 0
      )
        ? res.push('red')
        : ''

      this.events.some(
        (event) => event.StartTime.startsWith(date) && event.AlarmId > 0
      )
        ? res.push('yellow')
        : ''

      return res
    },

    /// ----------------------------------------------------------------------
    ///
    /// ----------------------------------------------------------------------
    updateDisplayedMonth () {
      // The displayed month and year can be retrieved using this.$refs.datePicker.current
      const displayedMonth = this.$refs.picker.tableDate
      const parts = displayedMonth.split('-')

      const year = parseInt(parts[0])
      const month = parseInt(parts[1])

      this.firstDay = new Date(year, month - 1, 1).toISOString().substr(0, 10)
      const lastDayDate = new Date(year, month, 0)
      this.lastDay = lastDayDate.toISOString().substr(0, 10)
      this.getTrips(this.firstDay, this.lastDay)
    },

    prevMonth () {
      this.$refs.picker.prev()
      this.updateDisplayedMonth()
    },

    nextMonth () {
      this.$refs.picker.next()
      this.updateDisplayedMonth()
    },

    /// ----------------------------------------------------------------------
    ///
    /// ----------------------------------------------------------------------
    getTrips (start, end) {
      this.isLoading = true

      let url = `${this.$baseUrl}/api/v2/trip/between`

      url += `?UnitID=${this.UnitID}`
      url += `&Start=${start}`
      url += `&End=${end}`

      return this.$axiosCache
        .get(url)
        .then((res) => {
          this.isLoading = false
          this.events = res.data
        })
        .catch((err) => {
          console.log('updateRange')
          console.log(err)
          this.isLoading = false
        })
    },

    /// ----------------------------------------------------------------------
    /// ----------------------------------------------------------------------
    allowedDates (date) {
      return date <= this.today
    },

    /// ----------------------------------------------------------------------
    /// ----------------------------------------------------------------------
    onDateSelected (val) {
      const route =
          '/timeline' +
          `/${this.$route.params.UnitID}` +
          `/${this.$route.params.VehicleReg}/day-select-timeline` +
          `/${val}` +
          `/${this.$route.params.VehicleID}`

      this.$router.push(route)
    }
  }
}
</script>
<style>
  .v-date-picker-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.5rem;
  }

  .has-event {
    background-color: #fff2a0;
  }
</style>
